import * as z from "zod";

const MarketplaceNotificationStatusSchema_ = z.discriminatedUnion("status", [
  z.object({ status: z.literal("complete") }),
  z.object({ status: z.literal("skipped") }),
  z.object({ status: z.literal("pending"), date: z.date().nullish() }),
  z.object({ status: z.literal("failed"), actionMessage: z.string() }),
]);
export const MarketplaceNotificationStatusSchema: z.ZodType<MarketplaceNotificationStatus> =
  MarketplaceNotificationStatusSchema_;

export type MarketplaceNotificationStatus = z.infer<
  typeof MarketplaceNotificationStatusSchema_
>;

export interface IMarketplaceNotificationStatus
  extends z.ZodType<MarketplaceNotificationStatus> {}
